import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withStudents } from "src/modules/student/operations";

import { withStateAndActionsForStudent } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, students, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"students"}
            component={RenderSelect}
            placeholder={"Students"}
            label={"Students"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(students?.map((student) => ({
                    id: student.id,
                    label: student.name || "",
                    value: JSON.stringify(student),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(
    withStateAndActionsForStudent,
    withStudents,
)(SubjectsField);
